import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgEarthquake(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M14.713 2L15 5l-3 3 2 2-3 4v-4L9 8l3-3-2.43-3H4v14h16V2z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Earthquake')(SvgEarthquake);
